/* MNTL launch countdown */
(function(){
"use strict";
var root=document.getElementById('cd'); if(!root) return;
var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var store={get:function(k,d){try{var v=localStorage.getItem(k);return v===null?d:JSON.parse(v)}catch(e){return d}},set:function(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
var LAUNCH=new Date(root.dataset.launch||'2026-11-25T08:00:00Z'); if(isNaN(LAUNCH)) LAUNCH=new Date('2026-11-25T08:00:00Z');

/* ---------- code decode ---------- */
var code=$('.cd-code'); setTimeout(function(){ code.classList.add('decode'); },RM?0:1100);

/* ---------- clock ---------- */
var units={d:$('[data-u="d"]'),h:$('[data-u="h"]'),m:$('[data-u="m"]'),s:$('[data-u="s"]')}, shown={};
function setDigit(el,ch){
  var cur=el.querySelector('b:not(.out)'); if(cur&&cur.textContent===ch) return;
  if(cur){ cur.classList.remove('in'); cur.classList.add('out'); setTimeout(function(){ if(cur.parentNode) cur.parentNode.removeChild(cur); },560); }
  var b=document.createElement('b'); b.textContent=ch; if(cur&&!RM) b.className='in'; el.appendChild(b);
}
function setUnit(u,v){
  var s=String(v); if(s.length<2) s='0'+s;
  var dg=$$('.cd-dg',units[u]);
  if(s.length>dg.length){ for(var k=dg.length;k<s.length;k++){ var n=document.createElement('span'); n.className='cd-dg'; units[u].insertBefore(n,units[u].firstChild); } dg=$$('.cd-dg',units[u]); }
  s.split('').forEach(function(ch,i){ setDigit(dg[i],ch); });
}
var liveShown=false, lastSr=-1;
function tick(){
  var ms=LAUNCH-Date.now();
  if(ms<=0){
    if(!liveShown){ liveShown=true; $('#cdClock').hidden=true; $('#cdLive').hidden=false; $('#cdEyebrow').textContent='Launch day'; burst($('#cdLive'),40); setTimeout(function(){ location.reload(); },45000); }
    return;
  }
  var t=Math.floor(ms/1000), d=Math.floor(t/86400), h=Math.floor(t%86400/3600), m=Math.floor(t%3600/60), s=t%60;
  setUnit('d',d); setUnit('h',h); setUnit('m',m); setUnit('s',s);
  if(m!==lastSr){ lastSr=m; $('#cdSr').textContent=d+' days, '+h+' hours and '+m+' minutes until MNTL launches.'; }
}
tick(); setInterval(tick,250);

/* ---------- local time + cities ---------- */
function fmt(tz,opts){ try{ return new Intl.DateTimeFormat('en',Object.assign({timeZone:tz},opts)).format(LAUNCH); }catch(e){ return ''; } }
var myTz=''; try{ myTz=Intl.DateTimeFormat().resolvedOptions().timeZone||''; }catch(e){}
var local=new Intl.DateTimeFormat('en',{weekday:'long',day:'numeric',month:'long',hour:'numeric',minute:'2-digit'}).format(LAUNCH);
var city=(myTz.split('/').pop()||'').replace(/_/g,' ');

/* ---------- country guess (for help line + chips) ---------- */
var CA=/^America\/(Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|St_Johns|Regina|Moncton|Whitehorse|Yellowknife|Iqaluit)$/;
function guess(){ if(/^(Pacific\/Auckland|Pacific\/Chatham|NZ)/.test(myTz)) return 'nz'; if(/^Australia\//.test(myTz)) return 'au'; if(CA.test(myTz)) return 'ca'; if(/^(America\/|US\/|Pacific\/Honolulu)/.test(myTz)) return 'us'; return 'other'; }
var GEO=guess();
var HL=window.MNTL_HL||null, help=$('#cdHelp');
var QUICK={nz:['New Zealand','free call or text <b>1737</b> any time','111'],au:['Australia','call Lifeline on <b>13 11 14</b> or text 0477 13 11 14','000'],us:['the United States','call or text <b>988</b>, any time','911'],ca:['Canada','call or text <b>9-8-8</b>, any time','911']};
function paintHelp(cc){ help.innerHTML = QUICK[cc] ? 'Need to talk? In '+QUICK[cc][0]+', '+QUICK[cc][1]+'. In danger, call <b>'+QUICK[cc][2]+'</b>. Elsewhere: <a href="https://findahelpline.com" target="_blank" rel="noopener">findahelpline.com</a>.' : 'Need to talk? Find free, confidential support in your country at <a href="https://findahelpline.com" target="_blank" rel="noopener">findahelpline.com</a>. In danger, call your local emergency number.'; }
paintHelp(GEO);
/* ---------- click through locations ---------- */
var LOCS=$$('#cdCities button'), cur=0;
var FULL={weekday:'long',day:'numeric',month:'long',hour:'numeric',minute:'2-digit'};
LOCS.forEach(function(b,i){ var tz=b.dataset.tz||myTz; $('span',b).textContent=fmt(tz,{weekday:'short',hour:'numeric',minute:'2-digit'}).replace(/:00/,'');
  if(b.dataset.tz&&b.dataset.tz===myTz) b.classList.add('me');
  b.addEventListener('click',function(){ showLoc(i,true); }); });
function showLoc(i,user){
  if(!LOCS.length){ $('#cdLocal').innerHTML='That&rsquo;s <b>'+local.replace(' at ',', ')+'</b> where you are'+(city?' ('+city+')':'')+'.'; return; }
  cur=(i+LOCS.length)%LOCS.length; var b=LOCS[cur];
  LOCS.forEach(function(x,k){ x.setAttribute('aria-pressed',String(k===cur)); });
  var el=$('#cdLocal');
  if(!b.dataset.tz){ el.innerHTML='That&rsquo;s <b>'+local.replace(' at ',', ')+'</b> where you are'+(city?' ('+city+')':'')+'.'; paintHelp(GEO); }
  else { el.innerHTML='In '+b.dataset.name+' it&rsquo;s <b>'+fmt(b.dataset.tz,FULL).replace(' at ',', ')+'</b>.'; paintHelp(b.dataset.cc||'other'); }
  if(user&&!RM){ el.classList.remove('flip'); void el.offsetWidth; el.classList.add('flip'); }
  if(user) b.scrollIntoView({block:'nearest',inline:'center',behavior:RM?'auto':'smooth'});
}
var pv=$('#cdPrev'), nx=$('#cdNextLoc');
if(pv) pv.addEventListener('click',function(){ showLoc(cur-1,true); });
if(nx) nx.addEventListener('click',function(){ showLoc(cur+1,true); });
if(!LOCS.length){ if(pv) pv.hidden=true; if(nx) nx.hidden=true; }
showLoc(0,false);
/* ---------- reader: our story + manifesto ---------- */
var lastOpen=null;
function openReader(id){
  var r=$('#cdReader-'+id); if(!r) return; lastOpen=document.activeElement;
  r.hidden=false; document.documentElement.style.overflow='hidden';
  var sc=$('.cd-rscroll',r); sc.scrollTop=0; setTimeout(function(){ $('.cd-rclose',r).focus(); },50);
  try{ history.pushState({cdr:id},'','#'+id); }catch(e){}
}
function closeReader(toJoin){
  $$('.cd-reader').forEach(function(r){ r.hidden=true; }); document.documentElement.style.overflow='';
  if(location.hash==='#story'||location.hash==='#manifesto'){ try{ history.replaceState(null,'',location.pathname+location.search); }catch(e){} }
  if(toJoin){ var f=$('#cdForm'); f.scrollIntoView({block:'center',behavior:RM?'auto':'smooth'}); setTimeout(function(){ var e=$('#cdEmail'); if(e&&!e.closest('[hidden]')) e.focus({preventScroll:true}); },500); }
  else if(lastOpen&&lastOpen.focus) lastOpen.focus();
}
$$('[data-open]').forEach(function(b){ b.addEventListener('click',function(){ openReader(b.dataset.open); }); });
$$('.cd-reader [data-close]').forEach(function(b){ b.addEventListener('click',function(){ closeReader(b.hasAttribute('data-tojoin')); }); });
$$('.cd-reader').forEach(function(r){ var sc=$('.cd-rscroll',r), bar=$('.cd-rprog i',r);
  sc.addEventListener('scroll',function(){ var p=sc.scrollTop/Math.max(1,sc.scrollHeight-sc.clientHeight); bar.style.width=(p*100).toFixed(1)+'%'; },{passive:true}); });
document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&$$('.cd-reader').some(function(r){return !r.hidden})) closeReader(false); });
window.addEventListener('popstate',function(){ if(location.hash!=='#story'&&location.hash!=='#manifesto') closeReader(false); });
if(location.hash==='#story'||location.hash==='#manifesto') openReader(location.hash.slice(1));


/* ---------- sign-up ---------- */
var form=$('#cdForm'), steps=$$('[data-cd-step]',form), bars=$$('.cd-steps i',form), email=$('#cdEmail'), err=$('#cdErr');
var EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var ME=store.get('mntl-cd',{})||{};
function go(n,focus){
  steps.forEach(function(s){ s.hidden=+s.dataset.cdStep!==n; });
  bars.forEach(function(b,i){ b.classList.toggle('on',i<n); });
  if(focus){ var f=steps[n-1].querySelector('input,button'); if(f) setTimeout(function(){ f.focus({preventScroll:true}); },60); }
}
$('#cdNext').addEventListener('click',function(){
  var v=(email.value||'').trim(); email.removeAttribute('aria-invalid');
  if(!EMAIL.test(v)){ err.textContent='Enter an email address like you@example.com.'; email.setAttribute('aria-invalid','true'); email.focus(); return; }
  err.textContent=''; go(2,true);
});
email.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); $('#cdNext').click(); } });
$('#cdBack').addEventListener('click',function(){ go(1,true); });
var country=GEO, wants={};
function paintCountry(){ window.__cdCountry=country; $$('#cdCountry button').forEach(function(b){ b.setAttribute('aria-pressed',String(b.dataset.c===country)); }); }
$$('#cdCountry button').forEach(function(b){ b.addEventListener('click',function(){ country=country===b.dataset.c?'':b.dataset.c; paintCountry(); }); });
$$('#cdWant button').forEach(function(b){ b.addEventListener('click',function(){ wants[b.dataset.w]=!wants[b.dataset.w]; b.setAttribute('aria-pressed',String(!!wants[b.dataset.w])); }); });
paintCountry();
form.addEventListener('submit',function(e){
  var v=(email.value||'').trim();
  if(!EMAIL.test(v)){ e.preventDefault(); go(1,true); err.textContent='Enter an email address like you@example.com.'; return; }
  var tags=$('#cdTags'), t=tags.value.split(',').map(function(x){return x.trim()}).filter(Boolean);
  if(country) t.push('country-'+country);
  if(store.get('mntl-cd-prize',false)) t.push('game-prize');
  Object.keys(wants).forEach(function(k){ if(wants[k]) t.push('want-'+k); });
  tags.value=t.join(', ');
  ME={name:($('#cdName').value||'').trim().slice(0,30),pending:true}; store.set('mntl-cd',ME);
  $('#cdSubmit').classList.add('loading');
});
function thanks(){
  var n=(ME.name||'').trim();
  $('#cdThanks').textContent=n?'You’re on the list, '+n+'.':'You’re on the list.';
  $('#cdTkNo').textContent=n||'you';
  $('#cdTkTime').textContent=local.replace(' at ',', ')+' your time';
  go(3); burst($('#cdTicket'),30);
}
var ok=!!$('[data-cd-ok]',form)||/customer_posted=true/.test(location.search);
if(ok&&ME.pending){ ME.pending=false; ME.done=true; store.set('mntl-cd',ME); thanks(); setTimeout(function(){ form.scrollIntoView({block:'center',behavior:RM?'auto':'smooth'}); },300); }
else if(ME.done){ thanks(); }
else if((err.textContent||'').trim()){ go(1); setTimeout(function(){ form.scrollIntoView({block:'center'}); },300); }
else go(1);

/* calendar + share */
function pad(n){ return (n<10?'0':'')+n; }
function icsDate(d){ return d.getUTCFullYear()+pad(d.getUTCMonth()+1)+pad(d.getUTCDate())+'T'+pad(d.getUTCHours())+pad(d.getUTCMinutes())+'00Z'; }
$('#cdCal').addEventListener('click',function(){
  var url=root.dataset.shop||location.origin, end=new Date(LAUNCH.getTime()+3600000);
  var ics=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//MNTL//Launch//EN','BEGIN:VEVENT','UID:mntl-launch-20261125@staymntl.com','DTSTAMP:'+icsDate(new Date()),'DTSTART:'+icsDate(LAUNCH),'DTEND:'+icsDate(end),'SUMMARY:MNTL launches. Move now.','DESCRIPTION:The MNTL store opens. $5 from every item to youth mental-health support. '+url,'URL:'+url,'BEGIN:VALARM','TRIGGER:-PT15M','ACTION:DISPLAY','DESCRIPTION:MNTL opens in 15 minutes','END:VALARM','END:VEVENT','END:VCALENDAR'].join('\r\n');
  var a=document.createElement('a'); a.href=URL.createObjectURL(new Blob([ics],{type:'text/calendar'})); a.download='MNTL-launch.ics'; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); },500);
  $('#cdShareMsg').textContent='Calendar file downloaded. Open it to add the launch.';
});
$('#cdShare').addEventListener('click',function(){
  var url=root.dataset.shop||location.origin, text='MNTL launches 25.11.26. Move now. Think later. $5 from every item goes to youth mental-health support.';
  if(navigator.share){ navigator.share({title:'MNTL',text:text,url:url}).catch(function(){}); return; }
  try{ navigator.clipboard.writeText(text+' '+url).then(function(){ $('#cdShareMsg').textContent='Link copied. Send it to someone who needs the reminder.'; }); }catch(e){ $('#cdShareMsg').textContent=url; }
});

/* ---------- game ---------- */
var track=$('#cdTrack');
if(track){
  var zone=$('#cdZone'), runner=$('#cdRunner'), res=$('#cdResult'), btn=$('#cdMove');
  var LINES=['Moved. That’s the hard part.','Again. Faster this time.','You didn’t overthink it.','Built under pressure.','Still moving.','Always MNTL.','That’s momentum.','Keep going.'];
  var G={x:0,dir:1,speed:.55,zone:[.5,.7],run:false,last:0,raf:0,streak:0,best:store.get('mntl-cd-best',0)};
  $('#cdBest').textContent=G.best;
  function setZone(){ var w=Math.max(.09,.22-G.streak*.018), s=.12+Math.random()*(.86-w-.12); G.zone=[s,s+w]; zone.style.left=(s*100)+'%'; zone.style.width=(w*100)+'%'; }
  function pos(){ runner.style.left='calc(10px + '+(G.x*100)+'% - '+(G.x*64)+'px)'; }
  function loop(t){ if(!G.run) return; var dt=Math.min(.05,(t-G.last)/1000); G.last=t; G.x+=G.dir*G.speed*dt; if(G.x>=1){G.x=1;G.dir=-1} if(G.x<=0){G.x=0;G.dir=1} pos(); G.raf=requestAnimationFrame(loop); }
  function start(){ G.run=true; G.last=performance.now(); runner.classList.remove('hit'); btn.textContent='Move now'; cancelAnimationFrame(G.raf); G.raf=requestAnimationFrame(loop); }
  function stop(){
    if(!G.run){ start(); return; }
    G.run=false; cancelAnimationFrame(G.raf);
    var tr=track.getBoundingClientRect(), rr=runner.getBoundingClientRect(), cx=(rr.left+rr.width/2-tr.left)/tr.width, inZ=cx>=G.zone[0]&&cx<=G.zone[1];
    if(inZ){ G.streak++; G.speed=Math.min(2.2,G.speed*1.12); runner.classList.add('hit'); burst(runner,12); if(G.streak>G.best){ G.best=G.streak; store.set('mntl-cd-best',G.best); }
      res.innerHTML=(G.streak===1?'Hit.':G.streak+' in a row.')+'<small>'+(goal&&!WON&&G.streak<TARGET?(TARGET-G.streak)+' more for '+PCT+' off.':LINES[(G.streak-1)%LINES.length])+'</small>'; setZone();
      if(goal&&!WON&&G.streak>=TARGET){ win(); } setTimeout(start,RM?0:650); }
    else { res.innerHTML=(G.streak?'Streak over at '+G.streak+'.':'Missed.')+'<small>Doesn’t matter. You moved. Go again.</small>'; if(window.MNTL_LB) MNTL_LB.ended(G.streak); G.streak=0; G.speed=.55; setZone(); btn.textContent='Go again'; }
    $('#cdStreak').textContent=G.streak; $('#cdBest').textContent=G.best; paintGoal();
  }
  /* prize: reach the target streak, win the code */
  var goal=$('#cdGoal'), prize=$('#cdPrize'), TARGET=goal?(+goal.dataset.target||5):0, PCT=(($('.cd-goal-txt b')||{}).textContent||'20% off').replace(/ off$/,'');
  var CODE=''; try{ CODE=goal?atob(goal.dataset.code||''):''; }catch(e){}
  var WON=!!store.get('mntl-cd-prize',false);
  function paintGoal(){ if(!goal) return; $$('.cd-goal-dots i',goal).forEach(function(d,i){ d.classList.toggle('on',WON||i<G.streak); }); goal.classList.toggle('won',WON); }
  function reveal(anim){ if(!prize) return; prize.hidden=false; $('#cdCode').textContent=CODE; $('.cd-goal-txt',goal).innerHTML='Won: <b>'+PCT+' off</b> saved below. Keep going for the leaderboard.'; paintGoal(); if(anim){ burst(goal,40); setTimeout(function(){ burst($('#cdCoupon'),24); },350); } }
  function win(){ WON=true; store.set('mntl-cd-prize',true);
    res.innerHTML=TARGET+' in a row. You won '+PCT+' off.<small>Your code&rsquo;s saved below. Don&rsquo;t stop now.</small>'; reveal(true); }
  if(prize){
    $('#cdCoupon').addEventListener('click',function(){ var l=$('#cdCopyLbl');
      var ok=function(){ l.textContent='Copied. Save it for 25.11.26'; setTimeout(function(){ l.textContent='Tap to copy'; },2400); };
      try{ navigator.clipboard.writeText(CODE).then(ok,function(){ l.textContent='Code: '+CODE; }); }catch(e){ l.textContent='Code: '+CODE; } });
    $('#cdPrizeCal').addEventListener('click',function(){
      var url=root.dataset.shop||location.origin, end=new Date(LAUNCH.getTime()+3600000);
      var ics=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//MNTL//Prize//EN','BEGIN:VEVENT','UID:mntl-prize-20261125@staymntl.com','DTSTAMP:'+icsDate(new Date()),'DTSTART:'+icsDate(LAUNCH),'DTEND:'+icsDate(end),'SUMMARY:MNTL opens. Use '+CODE+' for '+PCT+' off','DESCRIPTION:Your MNTL grand opening code: '+CODE+' ('+PCT+' off\\, one use). '+url,'URL:'+url,'BEGIN:VALARM','TRIGGER:-PT15M','ACTION:DISPLAY','DESCRIPTION:MNTL opens in 15 minutes. Code '+CODE,'END:VALARM','END:VEVENT','END:VCALENDAR'].join('\r\n');
      var a=document.createElement('a'); a.href=URL.createObjectURL(new Blob([ics],{type:'text/calendar'})); a.download='MNTL-launch-code.ics'; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); },500);
      $('#cdPrizeMsg').textContent='Saved to a calendar file with your code in it. Open it to add the reminder.'; });
    $('#cdPrizeMail').addEventListener('click',function(){
      var tags=$('#cdTags'); if(tags&&tags.value.indexOf('game-prize')<0) tags.value+=', game-prize';
      store.set('mntl-cd-prize-mail',true);
      if(ME.done){ $('#cdPrizeMsg').textContent='You&rsquo;re already on the list, so it&rsquo;s coming with your launch email.'.replace(/&rsquo;/g,'\u2019'); return; }
      go(1); var f=$('#cdForm'); f.scrollIntoView({block:'center',behavior:RM?'auto':'smooth'});
      var k=$('.cd-kicker',f); if(k) k.textContent='Your '+PCT+' code, in your inbox';
      setTimeout(function(){ email.focus({preventScroll:true}); },500); });
    if(WON) reveal(false);
  }
  paintGoal();
  btn.addEventListener('click',stop);
  track.addEventListener('pointerdown',function(e){ e.preventDefault(); stop(); });
  setZone(); pos(); btn.textContent='Start';
}


/* ---------- live leaderboard (Supabase) ---------- */
(function(){
  var lb=$('#cdLb'); if(!lb||!lb.dataset.url||!lb.dataset.key) return;
  var URLB=lb.dataset.url.replace(/\/+$/,'')+'/rest/v1/scores', KEY=lb.dataset.key, list=$('#cdLbList'), form=$('#cdLbForm'), mine=$('#cdLbMine');
  var H={'apikey':KEY,'Authorization':'Bearer '+KEY,'Content-Type':'application/json'};
  var PID=store.get('mntl-cd-pid',null); if(!PID){ PID=(crypto&&crypto.randomUUID)?crypto.randomUUID():'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g,function(){return (Math.random()*16|0).toString(16)}); store.set('mntl-cd-pid',PID); }
  var NAME=store.get('mntl-cd-name',''), POSTED=store.get('mntl-cd-posted',0), pending=0;
  var BAD=/(fuck|shit|cunt|bitch|dick|cock|pussy|nigg|fag|slut|whore|rape|nazi|kill|suicid)/i;
  var FLAG={nz:'NZ',au:'AU',us:'US',ca:'CA'};
  function esc(x){ return String(x).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]}); }
  function paint(rows){
    var seen={}, top=[]; rows.forEach(function(r){ if(seen[r.player]) return; seen[r.player]=1; if(!BAD.test(r.name)) top.push(r); });
    top=top.slice(0,10);
    list.innerHTML = top.length ? top.map(function(r,i){ return '<li class="'+(r.player===PID?'me':'')+'"><span class="rk">'+(i+1)+'</span><span class="nm">'+esc(r.name)+(FLAG[r.country]?' <small>'+FLAG[r.country]+'</small>':'')+'</span><b>'+r.score+'</b></li>'; }).join('')
      : '<li class="empty">No scores yet. The top spot is open.</li>';
    var best=store.get('mntl-cd-best',0); mine.textContent = best ? 'Your best: '+best+(NAME?' · posted as '+NAME:'') : 'Play to get on the board.';
  }
  function load(){ return fetch(URLB+'?select=player,name,score,country,created_at&order=score.desc,created_at.asc&limit=80',{headers:H}).then(function(r){ return r.ok?r.json():[]; }).then(paint).catch(function(){ list.innerHTML='<li class="empty">Leaderboard is taking a breather. Back soon.</li>'; }); }
  function post(score){
    if(!NAME||score<=POSTED) return Promise.resolve();
    var cc=(window.__cdCountry||GEO); cc=FLAG[cc]?cc:'other';
    return fetch(URLB,{method:'POST',headers:Object.assign({'Prefer':'return=minimal'},H),body:JSON.stringify({player:PID,name:NAME,score:score,country:cc})})
      .then(function(r){ if(r.ok){ POSTED=score; store.set('mntl-cd-posted',score); } return load(); }).catch(function(){});
  }
  function ended(score){
    var best=Math.max(score,store.get('mntl-cd-best',0));
    if(best<=POSTED) return;
    if(NAME){ post(best); }
    else { pending=best; form.hidden=false; $('#cdLbScore').textContent=best; }
  }
  form.addEventListener('submit',function(e){
    e.preventDefault(); var inp=$('#cdLbName'), v=(inp.value||'').trim().replace(/\s+/g,' ').slice(0,12), msg=$('#cdLbMsg');
    if(!/^[A-Za-z0-9 .'_-]{1,12}$/.test(v)){ msg.textContent='Letters, numbers and spaces only, up to 12.'; inp.focus(); return; }
    if(BAD.test(v)){ msg.textContent='Pick another name.'; inp.focus(); return; }
    NAME=v; store.set('mntl-cd-name',v); msg.textContent=''; form.hidden=true; post(pending||store.get('mntl-cd-best',0));
  });
  window.MNTL_LB={ended:ended,reload:load};
  load(); setInterval(function(){ if(!document.hidden) load(); },20000);
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) load(); });
})();

/* ---------- owner password ---------- */
var ob=$('#cdOwnerBtn'), op=$('#cdOwner');
if(ob&&op){
  var open=function(){ op.hidden=false; ob.setAttribute('aria-expanded','true'); setTimeout(function(){ $('#cdPw').focus(); },50); };
  var close=function(){ op.hidden=true; ob.setAttribute('aria-expanded','false'); ob.focus(); };
  ob.addEventListener('click',open); $('#cdOwnerClose').addEventListener('click',close);
  op.addEventListener('click',function(e){ if(e.target===op) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!op.hidden) close(); });
  if($('[data-pw-err]')) open();
}

function burst(from,n){
  if(RM||!from||!document.body.animate) return;
  var r=from.getBoundingClientRect(), x=r.left+r.width/2, y=r.top+r.height/2, cols=['#FF5A1F','#EDE8DF','#FF5A1F','#B8976B'];
  for(var i=0;i<n;i++){ var d=document.createElement('span'); d.className='cd-burst'; var s=6+Math.random()*12; d.style.width=d.style.height=s+'px'; d.style.background=cols[i%4]; document.body.appendChild(d);
    var a=Math.random()*Math.PI*2, dist=60+Math.random()*140;
    d.animate([{transform:'translate('+(x-s/2)+'px,'+(y-s/2)+'px)',opacity:1},{transform:'translate('+(x-s/2+Math.cos(a)*dist)+'px,'+(y-s/2+Math.sin(a)*dist+50)+'px) scale(.3)',opacity:0}],{duration:800+Math.random()*500,easing:'cubic-bezier(.2,.8,.2,1)'}).onfinish=(function(el){return function(){el.remove()}})(d); }
}
})();

/* v2: scroll reveal + $5 counter */
(function(){
  var root=document.getElementById('cd'); if(!root) return;
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=Array.prototype.slice.call(root.querySelectorAll('[data-rv]'));
  if(RM||!('IntersectionObserver' in window)){ els.forEach(function(e){ e.removeAttribute('data-rv'); }); return; }
  root.classList.add('rv-js');
  function count(el){
    var n=el.querySelector('.cd-five-n'); if(!n) return;
    var to=parseInt(n.textContent.replace(/[^0-9]/g,''),10)||5, st=0; n.textContent='$0';
    function f(ts){ if(!st) st=ts; var p=Math.min(1,(ts-st)/900), e=1-Math.pow(1-p,3); n.textContent='$'+Math.round(e*to);
      if(p<1){ requestAnimationFrame(f); } else if(n.animate){ n.animate([{transform:'scale(1)'},{transform:'scale(1.08)'},{transform:'scale(1)'}],{duration:450,easing:'cubic-bezier(.16,1,.3,1)'}); } }
    setTimeout(function(){ requestAnimationFrame(f); },280);
  }
  var io=new IntersectionObserver(function(ents){
    ents.forEach(function(en){
      if(!en.isIntersecting) return;
      var el=en.target; io.unobserve(el); el.classList.add('rv-on');
      if(el.classList.contains('cd-five')) count(el);
      setTimeout(function(){ el.removeAttribute('data-rv'); el.classList.remove('rv-on'); },1500);
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:0.12});
  els.forEach(function(e){ io.observe(e); });
})();
